import './scss/style.scss';
window.addEventListener('scroll', handleScroll);

// 既存の<section class="header">要素を取得
const sectionHeader = document.querySelector('.header');

// 新しいdiv要素（burger）を作成
const divBurger = document.createElement('div');
divBurger.classList.add('burger');

// 新しいdiv要素（wrap）を作成
const divWrap = document.createElement('div');
divWrap.classList.add('wrap');

// span要素を作成してdivWrap要素に追加
for (let i = 0; i < 3; i++) {
  const span = document.createElement('span');
  divWrap.appendChild(span);
}

// p要素を作成してテキストを設定
const pMenu = document.createElement('p');
pMenu.textContent = 'メニュー';

// divWrap要素の下にp要素を追加
divBurger.appendChild(divWrap);
divBurger.appendChild(pMenu);

// bodyの最初の子要素としてdivBurger要素を追加
document.body.insertBefore(divBurger, document.body.firstChild);

const burger = document.querySelector('.burger');
const header = document.querySelector('.header');

burger.addEventListener('click', function() {
  header.classList.toggle('open');
  burger.classList.toggle('open');
});
var headerElement = document.querySelector('.header');
var previousScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

function handleScroll() {
  var currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollPosition > previousScrollPosition) {
    // 下スクロール
    headerElement.classList.add('close');
  } else {
    // 上スクロール
    headerElement.classList.remove('close');
  }

  previousScrollPosition = currentScrollPosition;
}

const newsElement = document.querySelector('.news-sns__news');
// 新しい span 要素を作成します
const spanElement = document.createElement('span');
spanElement.classList.add('news-sns__news--bugle');

try {
  // span 要素を newsElement の子要素として追加します
  newsElement.appendChild(spanElement);
} catch (error) {
  // エラーメッセージを表示します
}


const snsElement = document.querySelector('.news-sns__sns');
// 新しい span 要素を作成します
const spansnsElement = document.createElement('span');
spansnsElement.classList.add('news-sns__sns--bugle');
try {
  // span 要素を snsElement の子要素として追加します
  snsElement.appendChild(spansnsElement);
} catch (error) {
}

// 要素を取得します
var titleElement = document.querySelector('.news-sns__news--title');

if (titleElement) {
  var content = titleElement.textContent;
  var before = content.substring(0, 3);
  var charToStyle = content.charAt(3);
  var after = content.substring(4);

  var highlightSpanElement = document.createElement('span');
  highlightSpanElement.textContent = charToStyle;
  highlightSpanElement.classList.add('highlight-letter');

  titleElement.textContent = '';

  try {
    titleElement.appendChild(document.createTextNode(before));
    titleElement.appendChild(highlightSpanElement);
    titleElement.appendChild(document.createTextNode(after));
  } catch (error) {
  }
} else {
}


var titlesnsElement = document.querySelector('.news-sns__sns--title');

if (titlesnsElement) {
  var content = titlesnsElement.textContent;
  var extractedText = content.substring(0, 4);

  var highlightSpanElement = document.createElement('span');
  highlightSpanElement.textContent = extractedText;

  titlesnsElement.textContent = '';

  try {
    titlesnsElement.appendChild(highlightSpanElement);
    titlesnsElement.appendChild(document.createTextNode(content.substring(4)));
  } catch (error) {
  }
} else {
}

// .section-deco1要素を取得
var sectionDeco1 = document.querySelector('.section-deco1');
if (sectionDeco1) {
  // 新しい<div>要素1を作成
  var divElement1 = document.createElement('div');
  // <div>要素1にクラスを追加
  divElement1.classList.add('left-deco1');
  // ここで<div>要素1に必要な属性や内容を追加することができます
  // 新しい<div>要素2を作成
  var divElement2 = document.createElement('div');
  // <div>要素2にクラスを追加
  divElement2.classList.add('right-deco1');
  // ここで<div>要素2に必要な属性や内容を追加することができます
  // .section-deco1要素の子要素として<div>要素1を追加
  sectionDeco1.appendChild(divElement1);
  // .section-deco1要素の子要素として<div>要素2を追加
  sectionDeco1.appendChild(divElement2);
}

// .section-deco2要素を取得
var sectionDeco2 = document.querySelector('.section-deco2');
if (sectionDeco2) {
  // 新しい<div>要素1を作成
  var divElement3 = document.createElement('div');
  // <div>要素1にクラスを追加
  divElement3.classList.add('left-deco2');
  // ここで<div>要素1に必要な属性や内容を追加することができます
  // 新しい<div>要素2を作成
  var divElement4 = document.createElement('div');
  // <div>要素2にクラスを追加
  divElement4.classList.add('right-deco2');
  // ここで<div>要素2に必要な属性や内容を追加することができます
  // .section-deco2要素の子要素として<div>要素1を追加
  sectionDeco2.appendChild(divElement3);
  // .section-deco2要素の子要素として<div>要素2を追加
  sectionDeco2.appendChild(divElement4);
}

// .section-deco3要素を取得
var sectionDeco3 = document.querySelector('.section-deco3');
if (sectionDeco3) {
  // 新しい<div>要素1を作成
  var divElement5 = document.createElement('div');
  // <div>要素1にクラスを追加
  divElement5.classList.add('left-deco3');
  // ここで<div>要素1に必要な属性や内容を追加することができます
  // 新しい<div>要素2を作成
  var divElement6 = document.createElement('div');
  // <div>要素2にクラスを追加
  divElement6.classList.add('right-deco3');
  // ここで<div>要素2に必要な属性や内容を追加することができます
  // .section-deco3要素の子要素として<div>要素1を追加
  sectionDeco3.appendChild(divElement5);
  // .section-deco3要素の子要素として<div>要素2を追加
  sectionDeco3.appendChild(divElement6);
}

// .main-image要素を取得
try {
  var mainImageElement = document.querySelector('.main-image');

  if (!mainImageElement) {
    throw new Error('.main-image要素が見つかりませんでした。');
  }

  var decoWrapElement = document.createElement('div');
  decoWrapElement.classList.add('main-image__deco-wrap');

  for (var i = 1; i <= 1; i++) {
    var characterElement = document.createElement('div');
    characterElement.classList.add('main-image__character' + i);
    decoWrapElement.appendChild(characterElement);
  }

  mainImageElement.appendChild(decoWrapElement);
} catch (error) {
  console.error('エラーが発生しました:', error);
}


// スクロールイベントを監視
try {
  var leftDeco1Element = document.querySelector(".left-deco1");
  leftDeco1Element.innerHTML = `<div class="left-deco1__character"></div>`;
} catch (error) {
}

try {
  var rightDeco1Element = document.querySelector(".right-deco1");
  rightDeco1Element.innerHTML = `<div class="right-deco1__character"></div>`;
} catch (error) {
}

try {
  var leftDeco2Element = document.querySelector(".left-deco2");
  leftDeco2Element.innerHTML = `<div class="left-deco2__character"></div>`;
} catch (error) {
}

try {
  var rightDeco2Element = document.querySelector(".right-deco2");
  rightDeco2Element.innerHTML = `<div class="right-deco2__character"></div>`;
} catch (error) {
}

try {
  var leftDeco3Element = document.querySelector(".left-deco3");
  leftDeco3Element.innerHTML = `<div class="left-deco3__character"></div>`;
} catch (error) {
}

try {
  var rightDeco3Element = document.querySelector(".right-deco3");
  rightDeco3Element.innerHTML = `<div class="right-deco3__character"></div>`;
} catch (error) {
}

try {
  var bugleElement = document.querySelector(".news-sns__sns--bugle");
  bugleElement.innerHTML = `<div class="news-sns__news--star"></div>`;
} catch (error) {
}

document.addEventListener('DOMContentLoaded', function() {
  const h2Elements = document.querySelectorAll('h2');
  h2Elements.forEach(element => {
    const classNames = element.className.split(' ');

    if (classNames.includes('title-deco1')) {
      element.innerHTML = '<div class="title-deco1__obj"></div>' + element.innerHTML;
    }
    if (classNames.includes('title-deco2')) {
      element.innerHTML = '<div class="title-deco2__obj"></div>' + element.innerHTML;
    }
    if (classNames.includes('title-deco3')) {
      element.innerHTML = '<div class="title-deco3__obj"></div>' + element.innerHTML;
    }
    if (classNames.includes('title-deco4')) {
      element.innerHTML = '<div class="title-deco4__obj"></div>' + element.innerHTML;
    }
    if (classNames.includes('title-deco5')) {
      element.innerHTML = '<div class="title-deco5__obj"></div>' + element.innerHTML;
    }
    if (classNames.includes('title-deco6')) {
      element.innerHTML = '<div class="title-deco6__obj"></div>' + element.innerHTML;
    }
    if (classNames.includes('title-deco7')) {
      element.innerHTML = '<div class="title-deco7__obj"></div>' + element.innerHTML;
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  const targetElement = document.querySelector('.wp-block-group.green-stripe.is-layout-constrained');

  if (targetElement) {
    const greenStripeRadius = document.createElement('div');
    greenStripeRadius.className = 'green-stripe-radius';

    targetElement.parentNode.insertBefore(greenStripeRadius, targetElement);
  }
});

// クリックイベントを取得する要素を取得
const kankyouLink = document.getElementById('kankyou');
const kosodateLink = document.getElementById('kosodate');
const nyuuenLink = document.getElementById('nyuuen');

// サブメニューを表示する要素を取得
const kankyouSubmenu = kankyouLink.querySelector('.submenu');
const kosodateSubmenu = kosodateLink.querySelector('.submenu');
const nyuuenSubmenu = nyuuenLink.querySelector('.submenu');

// クリックイベントを追加
kankyouLink.addEventListener('click', toggleSubmenuKankyou);
kosodateLink.addEventListener('click', toggleSubmenuKosodate);
nyuuenLink.addEventListener('click', toggleSubmenuNyuuen);

function toggleSubmenuKankyou(event) {
  kankyouSubmenu.classList.toggle('submenu-open');
  kosodateSubmenu.classList.remove('submenu-open');
  nyuuenSubmenu.classList.remove('submenu-open');
}

function toggleSubmenuKosodate(event) {
  kosodateSubmenu.classList.toggle('submenu-open');
  kankyouSubmenu.classList.remove('submenu-open');
  nyuuenSubmenu.classList.remove('submenu-open');
}

function toggleSubmenuNyuuen(event) {
  nyuuenSubmenu.classList.toggle('submenu-open');
  kankyouSubmenu.classList.remove('submenu-open');
  kosodateSubmenu.classList.remove('submenu-open');
}

// スクロールイベントを追加
window.addEventListener('scroll', removeSubmenu);

function removeSubmenu() {
  kankyouSubmenu.classList.remove('submenu-open');
  kosodateSubmenu.classList.remove('submenu-open');
  nyuuenSubmenu.classList.remove('submenu-open');
}